import { render } from "./StepBarWithIcon.vue?vue&type=template&id=60c4a03a"
import script from "./StepBarWithIcon.vue?vue&type=script&lang=ts"
export * from "./StepBarWithIcon.vue?vue&type=script&lang=ts"
script.render = render

export default script